import { createFileRoute } from "@tanstack/react-router";
import useAppStore from "@/store";
import { useEffect } from "react";
import { ChevronLeft, Loader2 } from "lucide-react";
import DataPlaceholder from "@/components/ui/shared/data-placeholder";
import { useTranslate } from "@/hooks/use-translate";
import DataChangeTable from "@/components/data-change/data-change-table";

export const Route = createFileRoute(
  "/(dasboard)/inventory/stock-batchs/$id/price-changes"
)({
  component: PriceChanges,
});

function PriceChanges() {
  const store = useAppStore();
  const stockBatch = store.stockBatch.current;
  const params = Route.useParams();
  const { t } = useTranslate();

  useEffect(() => {
    const id = params.id;
    if (id && store.auth.session) {
      store.stockBatch
        .fetchOne(id)
        .then((stockBatch: any) => {
          store.stockBatch.setCurrent(stockBatch);
        })
        .catch(store.errors.catch);
    }
  }, [params.id, store.auth.session]);

  if (!stockBatch) {
    return (
      <section>
        <>{store.errors.render()}</>
        <div className="h-24 bg-gray-200 rounded-md flex items-center justify-center">
          {store.loading.status.quantity ? (
            <div>
              <Loader2 className="animate-spin text-primary-400 mx-auto" />
              <p className="text-gray-600">Loading...</p>
            </div>
          ) : (
            <div>
              <DataPlaceholder />
            </div>
          )}
        </div>
      </section>
    );
  }

  return (
    <section>
      <div>
        <button
          type="button"
          onClick={() => window.history.back()}
          className="py-2 inline-flex gap-2 items-center justify-center rounded-lg text-sm text-gray-500 hover:text-gray-900 hover:underline font-semibold"
        >
          <ChevronLeft className="h-4 w-4" />
          <span className="">{t("Back")}</span>
        </button>
      </div>
      <h3 className="font-semibold mb-2">{t("Price changes")}</h3>
      <DataChangeTable changeable={{ type: "StockBatch", id: stockBatch.id }} />
    </section>
  );
}
